import { Box, Chip, Grid, Typography } from '@mui/material';
import { ReactElement } from 'react';

const getTriggerSideEffect = (data: any): any => {
  if (data?.can_trigger_side_effects === true) return 'Yes';
  if (data?.can_trigger_side_effects === false) return 'No';
  return '-';
};

const supportAgentic = (data: any): any => {
  if (data?.supports_agentic_workflows === true) return 'Yes';
  if (data?.supports_agentic_workflows === false) return 'No';
  return '-';
};

const CapabilityProfile = ({ data }: any): ReactElement => (
  <Box>
    <Grid container spacing={3}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Business Tasks Enabled
        </Typography>
        <Typography>{data?.business_tasks_enabled || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Connected Enterprise Systems
        </Typography>
        <Typography>{data?.connected_enterprise_systems || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Data Sources Accessed
        </Typography>
        <Typography>{data?.data_sources_accessed || '-'}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">Actions Supported</Typography>
        <Typography>
          {data?.actions_supported?.map((label: any) => (
            <Chip label={label} size="small" sx={{ margin: '2px 2px 2px 0' }} />
          )) || '-'}
        </Typography>
      </Grid>
      <Grid item md={6} sm={12}>
        <Typography className="mcp-details-title">
          Can Trigger Side Effects
        </Typography>
        <Typography>{getTriggerSideEffect(data)}</Typography>
      </Grid>
    </Grid>
    <Grid container spacing={3} mt={1}>
      <Grid item sm={12}>
        <Typography className="mcp-details-title">
          Supports Agentic Workflows
        </Typography>
        <Typography>{supportAgentic(data)}</Typography>
      </Grid>
    </Grid>
  </Box>
);

export default CapabilityProfile;
